import React, { useState } from "react";

interface Props {
  onSearch: (term: string) => void;
  loading: boolean;
  disabled: boolean;
}

export function SearchBar({ onSearch, loading, disabled }: Props) {
  const [term, setTerm] = useState("");

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const t = term.trim();
    if (t) onSearch(t);
  }

  return (
    <form onSubmit={handleSubmit} className="flex gap-2 mb-6">
      <input
        type="text"
        value={term}
        onChange={(e) => setTerm(e.target.value)}
        placeholder="Buscar produto (ex: arroz tio joao 5kg)"
        className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder:text-gray-400 dark:placeholder:text-gray-500"
        disabled={disabled}
        autoFocus
      />
      <button
        type="submit"
        disabled={disabled || !term.trim()}
        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? "Buscando..." : "Buscar"}
      </button>
    </form>
  );
}
